var _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.2,93.7,180,115H161.91L156,103.78c-6.75,1.69-10.11,2.62-17.65,2.62-6.55,0-9-.7-15-2l-6.1,11.51H99.16l.8-20.65A55.48,55.48,0,0,1,84.11,81.21,31.08,31.08,0,0,1,63.93,68.07H48.22V48.71H59.77C61.84,36.47,72.28,26.83,85.53,24.9l2.78-10.38,9,8.67c11.79-8,23.7-12.86,41.07-12.86,36.47,0,62.17,21.51,62.17,48C200.51,72.34,192.3,84.92,179.2,93.7Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176,90.48l.82,21.26H158.69l-5.92-11.18c-6.75,1.69-10.11,2.62-17.65,2.62-6.55,0-9-.7-15-2L114,112.7H95.94l.8-20.65A55.48,55.48,0,0,1,80.89,78,31.08,31.08,0,0,1,60.71,64.85H45V45.49H56.55c2.07-12.24,12.51-21.89,25.76-23.81L85.09,11.3l9,8.67c11.79-8,23.7-12.86,41.07-12.86,36.47,0,62.17,21.51,62.17,48C197.29,69.12,189.08,81.7,176,90.48Z",
    fill: "#ccefff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.39,25.91s6.08-4.8,1-9.51-.86-11.3,6.89-4.14,13.62.29,6.6-6.19",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "3 5"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 96.02,
    y1: 92.05,
    x2: 96.02,
    y2: 19.97
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.85,
    y1: 70.03,
    x2: 190.47,
    y2: 70.03
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.85,
    y1: 100.38,
    x2: 151.85,
    y2: 9.13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.47,
    y1: 28.51,
    x2: 96.47,
    y2: 28.51
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136,46.41l-2.74-2c-12.13-7-20.93,6.86-12,12.4l9.07,4.94C142,68,134,82.65,120.5,77.23l-5.87-2.89m11.61,12.1v-8m0-44v8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganize);
export default __webpack_public_path__ + "static/media/organize.13dbaee0.svg";
export { ForwardRef as ReactComponent };